<tgrid-layer-header [layer]="this" [additionIcons]="iconConfig()">

  <div ngProjectAs="filters">
    <form [formGroup]="filterGroup">
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Operational Status</mat-label>
        <mat-select formControlName="operationalStatus">
          <mat-option value="ALL">All</mat-option>
          @for (status of statuses.values(); track status.name) {
            <mat-option [value]="status">{{ status | datacenterOperationalStatus }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Provider Type</mat-label>
        <mat-select formControlName="provider">
          <mat-option value="ALL">All</mat-option>
          @for (provider of providers.values(); track provider.name) {
            <mat-option [value]="provider">{{ provider | datacenterProvider }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </div>

  <div class="legend">

    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'rgb(94,182,92)'"></div>
      <span>{{ statuses.OPERATIONAL | datacenterOperationalStatus }}</span>
    </div>
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'rgb(228,155,39'"></div>
      <span>{{ statuses.UNDER_CONSTRUCTION | datacenterOperationalStatus }}</span>
    </div>
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'rgb(72,118,251)'"></div>
      <span>{{ statuses.PLANNED | datacenterOperationalStatus }}</span>
    </div>
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'rgb(187,55,252)'"></div>
      <span>{{ statuses.LAND_HELD | datacenterOperationalStatus }}</span>
    </div>
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'rgb(153,153,153)'"></div>
      <span>{{ statuses.CANCELED | datacenterOperationalStatus }}</span>
    </div>
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'#444444'"></div>
      <span>Not Available</span>
    </div>

  </div>
</tgrid-layer-header>
